(function(jQuery)
{
	jQuery.framework = jQuery.framework || {};
	
	jQuery.framework.mediamode = function()
	{
		modes = {
			xsmall: {
				min: 0,
				max: 319
			},
			small: {
				min: 320,
				max: 639
			},
			medium: {
				min: 640,
				max: 1151
			}
		};
		
		currentWidth = screen.width;
		
		var thismode = "";
		
		for(var mode in modes)
		{
			if((modes[mode].min < jQuery(window).width()) && (modes[mode].max > jQuery(window).width()))
			{
				thismode = mode;
			}
		}
		
		return thismode;
	}
})(jQuery);
